import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '../graphql/ApolloHooksWithContext';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"context":{"clientName":"FEED"}} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Coins: { input: any; output: any; }
  Euro: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  admin: Scalars['Boolean']['output'];
  followers?: Maybe<Followers>;
  user?: Maybe<User>;
};

export type AdminMutation = {
  __typename?: 'AdminMutation';
  commentPost?: Maybe<Comment>;
  createUserMediaFeaturedPost: PostUpdated;
  deleteComment: Scalars['Boolean']['output'];
  deletePhoto: Scalars['Boolean']['output'];
  deletePost: Scalars['Boolean']['output'];
  editComment?: Maybe<Comment>;
  editPost: PostUpdated;
  pinPost: PostUpdated;
  unpinPost: PostUpdated;
};


export type AdminMutationCommentPostArgs = {
  postId: Scalars['ID']['input'];
  repliesToCommentId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type AdminMutationCreateUserMediaFeaturedPostArgs = {
  modelId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: FeaturedPostTypesEnum;
  umaId: Scalars['ID']['input'];
};


export type AdminMutationDeleteCommentArgs = {
  commentID: Scalars['ID']['input'];
};


export type AdminMutationDeletePhotoArgs = {
  photoId: Scalars['ID']['input'];
};


export type AdminMutationDeletePostArgs = {
  postId: Scalars['ID']['input'];
};


export type AdminMutationEditCommentArgs = {
  commentID: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type AdminMutationEditPostArgs = {
  fsk: FskEnum;
  pinned: Scalars['Boolean']['input'];
  postId: Scalars['ID']['input'];
  publicationScheduledFor?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type AdminMutationPinPostArgs = {
  postId: Scalars['ID']['input'];
};


export type AdminMutationUnpinPostArgs = {
  postId: Scalars['ID']['input'];
};

export type BuyPostResult = {
  __typename?: 'BuyPostResult';
  success: Scalars['Boolean']['output'];
};

export type ClipPost = Post & {
  __typename?: 'ClipPost';
  admin?: Maybe<Scalars['String']['output']>;
  clip?: Maybe<MediaVideo>;
  comments: Comments;
  contest?: Maybe<Contest>;
  created: Scalars['String']['output'];
  fsk: FskEnum;
  guestState?: Maybe<GuestPostState>;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  likes: Scalars['Int']['output'];
  model: User;
  paidContent: Scalars['Boolean']['output'];
  pinned: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Euro']['output']>;
  priceCoins?: Maybe<Scalars['Coins']['output']>;
  publicationScheduledFor?: Maybe<Scalars['String']['output']>;
  purchases?: Maybe<PurchasesSummary>;
  /** @deprecated Not implemented. Use `rejectionReason`. */
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejected: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: PostStatusEnum;
  text?: Maybe<Scalars['String']['output']>;
  tippingGoal?: Maybe<TippingGoal>;
  tips: TipsSummary;
  title?: Maybe<Scalars['String']['output']>;
  type: PostTypeEnum;
  umaId?: Maybe<Scalars['ID']['output']>;
  views: Scalars['Int']['output'];
};


export type ClipPostRejectionReasonArgs = {
  language?: RejectionReasonLanguageEnum;
};

export enum CollectionEnum {
  Chubby = 'CHUBBY',
  /** @deprecated Use CHUBBY */
  Curvy = 'CURVY',
  Darkskin = 'DARKSKIN',
  /** @deprecated Use FETISH_BDSM */
  Fetishbdsm = 'FETISHBDSM',
  FetishAll = 'FETISH_ALL',
  FetishBdsm = 'FETISH_BDSM',
  Grannies = 'GRANNIES',
  Milf = 'MILF',
  /** @deprecated Use GRANNIES */
  Omas = 'OMAS',
  Tattoos = 'TATTOOS',
  Teen = 'TEEN',
  Transsexual = 'TRANSSEXUAL',
  /** @deprecated Use TRANSSEXUAL */
  Transvestite = 'TRANSVESTITE'
}

export type Comment = {
  __typename?: 'Comment';
  conversationId: Scalars['ID']['output'];
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCreator: Scalars['Boolean']['output'];
  isReplyToReply: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
  tipped: Scalars['Boolean']['output'];
  user: User;
};

export type Comments = {
  __typename?: 'Comments';
  nodes: Array<Conversation>;
  totalCount: Scalars['Int']['output'];
};

export type Config = {
  __typename?: 'Config';
  paidContent: PaidContentConfig;
  paidContentCoins: PaidContentCoinsConfig;
  tippingGoal: TippingGoalConfig;
  tippingGoalCoins: TippingGoalCoinsConfig;
};

export type Contest = {
  __typename?: 'Contest';
  /** ID of Contest: `UMPA_ID` */
  id: Scalars['ID']['output'];
};

export type Conversation = {
  __typename?: 'Conversation';
  comment: Comment;
  replies: Array<Comment>;
};

export enum FeaturedPostTypesEnum {
  FpHotClip = 'FP_HOT_CLIP',
  FpPhotoGallery = 'FP_PHOTO_GALLERY'
}

export type Feed = {
  __typename?: 'Feed';
  id: Scalars['ID']['output'];
  posts: Posts;
};


export type FeedPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export enum FeedAgeRatingEnum {
  Nsfw = 'NSFW',
  Sfw = 'SFW'
}

export enum FeedModeEnum {
  Mixed = 'MIXED',
  Model = 'MODEL',
  Startpage = 'STARTPAGE'
}

export enum FeedPostCategoriesEnum {
  Featured = 'FEATURED',
  InProgress = 'IN_PROGRESS',
  Published = 'PUBLISHED'
}

export type FeedTotalCount = {
  __typename?: 'FeedTotalCount';
  bought: Scalars['Int']['output'];
  clips: Scalars['Int']['output'];
  commented: Scalars['Int']['output'];
  liked: Scalars['Int']['output'];
  photos: Scalars['Int']['output'];
  texts: Scalars['Int']['output'];
  tipped: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type Followers = {
  __typename?: 'Followers';
  count: Scalars['Int']['output'];
};

export enum FskEnum {
  Fsk16 = 'FSK16',
  Fsk18 = 'FSK18'
}

export type GuestPostState = {
  __typename?: 'GuestPostState';
  bought?: Maybe<Scalars['Boolean']['output']>;
  following: Scalars['Boolean']['output'];
  liked: Scalars['Boolean']['output'];
  viewed: Scalars['Boolean']['output'];
};

export type Like = {
  __typename?: 'Like';
  likedAt: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type Likes = {
  __typename?: 'Likes';
  likes: Array<Like>;
  totalCount: Scalars['Int']['output'];
};

export type MediaPicture = {
  __typename?: 'MediaPicture';
  avsRequired: Scalars['Boolean']['output'];
  blurred: Scalars['Boolean']['output'];
  fsk: FskEnum;
  /** ID of MediaPicture: `UMP_ID` */
  id: Scalars['ID']['output'];
  likes: Scalars['Int']['output'];
  rejected: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  srcSet: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type MediaPictureRejectionReasonArgs = {
  language?: RejectionReasonLanguageEnum;
};


export type MediaPictureUrlArgs = {
  size?: MediaPictureSizeEnum;
};

export enum MediaPictureSizeEnum {
  W40 = 'W40',
  W60 = 'W60',
  W140 = 'W140',
  W160 = 'W160',
  W320 = 'W320',
  W640 = 'W640',
  W1024 = 'W1024',
  W1280 = 'W1280',
  W1920 = 'W1920'
}

export type MediaVideo = {
  __typename?: 'MediaVideo';
  avsRequired: Scalars['Boolean']['output'];
  fsk: FskEnum;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Clip length in seconds */
  length: Scalars['Int']['output'];
  poster?: Maybe<MediaPicture>;
  ratio: Scalars['Float']['output'];
  sources: Array<MediaVideoSource>;
  width: Scalars['Int']['output'];
};

export type MediaVideoSource = {
  __typename?: 'MediaVideoSource';
  label: MediaVideoSourceLabelEnum;
  src: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum MediaVideoSourceLabelEnum {
  Hls = 'HLS'
}

export enum ModelPostTypesEnum {
  Clip = 'CLIP',
  Photos = 'PHOTOS',
  Text = 'TEXT'
}

export type Mutation = {
  __typename?: 'Mutation';
  admin: AdminMutation;
  vx: VxMutation;
  vxmodels: VxModelsMutation;
};

export type Pagination = {
  edges: Array<PaginationEdge>;
  pageInfo: PaginationPageInfo;
};

export type PaginationEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationPageInfo = {
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaidContentCoinsConfig = {
  __typename?: 'PaidContentCoinsConfig';
  max: Scalars['Coins']['output'];
  min: Scalars['Coins']['output'];
  step: Scalars['Coins']['output'];
  steps: Array<Maybe<Scalars['Coins']['output']>>;
};

export type PaidContentConfig = {
  __typename?: 'PaidContentConfig';
  max: Scalars['Euro']['output'];
  min: Scalars['Euro']['output'];
  step: Scalars['Euro']['output'];
  steps: Array<Maybe<Scalars['Euro']['output']>>;
};

export type PaidContentStat = {
  __typename?: 'PaidContentStat';
  amount?: Maybe<Scalars['Euro']['output']>;
  amountCoins?: Maybe<Scalars['Coins']['output']>;
  count: Scalars['Int']['output'];
};

export enum PeriodEnum {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type PhotoContestPostCreated = {
  __typename?: 'PhotoContestPostCreated';
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type PhotosPost = Post & {
  __typename?: 'PhotosPost';
  admin?: Maybe<Scalars['String']['output']>;
  comments: Comments;
  contest?: Maybe<Contest>;
  created: Scalars['String']['output'];
  fsk: FskEnum;
  guestState?: Maybe<GuestPostState>;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  likes: Scalars['Int']['output'];
  model: User;
  paidContent: Scalars['Boolean']['output'];
  photos?: Maybe<Array<MediaPicture>>;
  pinned: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Euro']['output']>;
  priceCoins?: Maybe<Scalars['Coins']['output']>;
  publicationScheduledFor?: Maybe<Scalars['String']['output']>;
  purchases?: Maybe<PurchasesSummary>;
  /** @deprecated Not implemented. Use `rejectionReason`. */
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejected: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: PostStatusEnum;
  text?: Maybe<Scalars['String']['output']>;
  tippingGoal?: Maybe<TippingGoal>;
  tips: TipsSummary;
  title?: Maybe<Scalars['String']['output']>;
  type: PostTypeEnum;
  umaId?: Maybe<Scalars['ID']['output']>;
  views: Scalars['Int']['output'];
};


export type PhotosPostRejectionReasonArgs = {
  language?: RejectionReasonLanguageEnum;
};

export type Post = {
  admin?: Maybe<Scalars['String']['output']>;
  comments: Comments;
  contest?: Maybe<Contest>;
  created: Scalars['String']['output'];
  fsk: FskEnum;
  guestState?: Maybe<GuestPostState>;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  likes: Scalars['Int']['output'];
  model: User;
  paidContent: Scalars['Boolean']['output'];
  pinned: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Euro']['output']>;
  priceCoins?: Maybe<Scalars['Coins']['output']>;
  publicationScheduledFor?: Maybe<Scalars['String']['output']>;
  purchases?: Maybe<PurchasesSummary>;
  /** @deprecated Not implemented. Use `rejectionReason`. */
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejected: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: PostStatusEnum;
  text?: Maybe<Scalars['String']['output']>;
  tippingGoal?: Maybe<TippingGoal>;
  tips: TipsSummary;
  title?: Maybe<Scalars['String']['output']>;
  type: PostTypeEnum;
  umaId?: Maybe<Scalars['ID']['output']>;
  views: Scalars['Int']['output'];
};


export type PostRejectionReasonArgs = {
  language?: RejectionReasonLanguageEnum;
};

export type PostChanged = {
  badwordsViolation: Scalars['Boolean']['output'];
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
};

export type PostCreated = PostChanged & {
  __typename?: 'PostCreated';
  badwordsViolation: Scalars['Boolean']['output'];
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
  uploadUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export enum PostStatusEnum {
  Broken = 'BROKEN',
  Deleted = 'DELETED',
  Hidden = 'HIDDEN',
  Ok = 'OK',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  Transcoding = 'TRANSCODING',
  Uploading = 'UPLOADING'
}

export enum PostTypeEnum {
  Clip = 'CLIP',
  CpPhotoContest = 'CP_PHOTO_CONTEST',
  FpHotClip = 'FP_HOT_CLIP',
  FpPhotoGallery = 'FP_PHOTO_GALLERY',
  Photos = 'PHOTOS',
  Text = 'TEXT'
}

export enum PostTypeGroupEnum {
  ClipPosts = 'CLIP_POSTS',
  PhotosPosts = 'PHOTOS_POSTS',
  TextPosts = 'TEXT_POSTS'
}

export type PostUpdated = PostChanged & {
  __typename?: 'PostUpdated';
  badwordsViolation: Scalars['Boolean']['output'];
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
};

export type Posts = Pagination & {
  __typename?: 'Posts';
  edges: Array<PostsEdge>;
  pageInfo: PostsPageInfo;
};

export type PostsEdge = PaginationEdge & {
  __typename?: 'PostsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Post;
};

export type PostsPageInfo = PaginationPageInfo & {
  __typename?: 'PostsPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
};

export type PurchasesSummary = {
  __typename?: 'PurchasesSummary';
  count: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  config: Config;
  feed: Feed;
  feedTotalCounts: FeedTotalCount;
  post?: Maybe<Post>;
  postLikes?: Maybe<Likes>;
  postSales?: Maybe<Sales>;
  postTips?: Maybe<Tips>;
  stats: Stats;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};


export type QueryFeedArgs = {
  ageRating?: InputMaybe<Array<FeedAgeRatingEnum>>;
  bought?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<FeedPostCategoriesEnum>>;
  collection?: InputMaybe<CollectionEnum>;
  commented?: InputMaybe<Scalars['Boolean']['input']>;
  featuredPosts?: InputMaybe<Scalars['Boolean']['input']>;
  follows?: InputMaybe<Scalars['Boolean']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<FeedModeEnum>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  statusList?: InputMaybe<Array<PostStatusEnum>>;
  tipped?: InputMaybe<Scalars['Boolean']['input']>;
  typeGroups?: InputMaybe<Array<PostTypeGroupEnum>>;
};


export type QueryFeedTotalCountsArgs = {
  ageRating?: InputMaybe<Array<FeedAgeRatingEnum>>;
  bought?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<FeedPostCategoriesEnum>>;
  commented?: InputMaybe<Scalars['Boolean']['input']>;
  featuredPosts?: InputMaybe<Scalars['Boolean']['input']>;
  follows?: InputMaybe<Scalars['Boolean']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['ID']['input'];
  statusList?: InputMaybe<Array<PostStatusEnum>>;
  tipped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPostArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryPostLikesArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryPostSalesArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryPostTipsArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryUploadUrlArgs = {
  photoId?: InputMaybe<Scalars['ID']['input']>;
  postId: Scalars['ID']['input'];
};

export enum RejectionReasonLanguageEnum {
  De = 'DE',
  En = 'EN'
}

export type Sale = {
  __typename?: 'Sale';
  amount?: Maybe<Scalars['Euro']['output']>;
  amountCoins?: Maybe<Scalars['Coins']['output']>;
  salesAt: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type Sales = {
  __typename?: 'Sales';
  sales: Array<Sale>;
  totalCount: Scalars['Int']['output'];
};

export type Stats = {
  __typename?: 'Stats';
  paidContentSales: Array<PaidContentStat>;
  tipping: Array<TippingStat>;
};


export type StatsPaidContentSalesArgs = {
  period: PeriodEnum;
};


export type StatsTippingArgs = {
  period: PeriodEnum;
};

export type TextPost = Post & {
  __typename?: 'TextPost';
  admin?: Maybe<Scalars['String']['output']>;
  comments: Comments;
  contest?: Maybe<Contest>;
  created: Scalars['String']['output'];
  fsk: FskEnum;
  guestState?: Maybe<GuestPostState>;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  likes: Scalars['Int']['output'];
  model: User;
  paidContent: Scalars['Boolean']['output'];
  pinned: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Euro']['output']>;
  priceCoins?: Maybe<Scalars['Coins']['output']>;
  publicationScheduledFor?: Maybe<Scalars['String']['output']>;
  purchases?: Maybe<PurchasesSummary>;
  /** @deprecated Not implemented. Use `rejectionReason`. */
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejected: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: PostStatusEnum;
  text?: Maybe<Scalars['String']['output']>;
  tippingGoal?: Maybe<TippingGoal>;
  tips: TipsSummary;
  title?: Maybe<Scalars['String']['output']>;
  type: PostTypeEnum;
  umaId?: Maybe<Scalars['ID']['output']>;
  views: Scalars['Int']['output'];
};


export type TextPostRejectionReasonArgs = {
  language?: RejectionReasonLanguageEnum;
};

export type Tip = {
  __typename?: 'Tip';
  amount?: Maybe<Scalars['Euro']['output']>;
  amountCoins?: Maybe<Scalars['Coins']['output']>;
  tippedAt: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type TipPostResult = {
  __typename?: 'TipPostResult';
  success: Scalars['Boolean']['output'];
};

export type TippingGoal = {
  __typename?: 'TippingGoal';
  achieved: Scalars['Boolean']['output'];
  goal?: Maybe<Scalars['Euro']['output']>;
  goalCoins?: Maybe<Scalars['Coins']['output']>;
  progressPercent: Scalars['Int']['output'];
  /** @deprecated Use `achieved`. */
  success: Scalars['Boolean']['output'];
  tipsSum?: Maybe<Scalars['Euro']['output']>;
  tipsSumCoins?: Maybe<Scalars['Coins']['output']>;
};

export type TippingGoalCoinsConfig = {
  __typename?: 'TippingGoalCoinsConfig';
  max: Scalars['Coins']['output'];
  min: Scalars['Coins']['output'];
  steps: Array<Maybe<Scalars['Coins']['output']>>;
};

export type TippingGoalConfig = {
  __typename?: 'TippingGoalConfig';
  max: Scalars['Euro']['output'];
  min: Scalars['Euro']['output'];
  steps: Array<Maybe<Scalars['Euro']['output']>>;
};

export type TippingStat = {
  __typename?: 'TippingStat';
  amount?: Maybe<Scalars['Euro']['output']>;
  amountCoins?: Maybe<Scalars['Coins']['output']>;
  count: Scalars['Int']['output'];
};

export type Tips = {
  __typename?: 'Tips';
  tips: Array<Tip>;
  totalCount: Scalars['Int']['output'];
};

export type TipsSummary = {
  __typename?: 'TipsSummary';
  amount?: Maybe<Scalars['Euro']['output']>;
  amountCoins?: Maybe<Scalars['Coins']['output']>;
  count: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<MediaPicture>;
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
  online: Scalars['Boolean']['output'];
};

export type VxModelsMutation = {
  __typename?: 'VXModelsMutation';
  commentPost?: Maybe<Comment>;
  createPhotoContextPost: PhotoContestPostCreated;
  createPost: PostCreated;
  deleteComment: Scalars['Boolean']['output'];
  deletePhoto: Scalars['Boolean']['output'];
  deletePost: Scalars['Boolean']['output'];
  editComment?: Maybe<Comment>;
  editPost: PostUpdated;
  pinPost: PostUpdated;
  reportComment: Scalars['Boolean']['output'];
  setUploadCompleted?: Maybe<PostUpdated>;
  unpinPost: PostUpdated;
};


export type VxModelsMutationCommentPostArgs = {
  postId: Scalars['ID']['input'];
  repliesToCommentId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};


export type VxModelsMutationCreatePhotoContextPostArgs = {
  contestId: Scalars['ID']['input'];
};


export type VxModelsMutationCreatePostArgs = {
  fsk: FskEnum;
  photosCount?: InputMaybe<Scalars['Int']['input']>;
  pinned: Scalars['Boolean']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  publicationScheduledFor?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  tippingGoal?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ModelPostTypesEnum;
};


export type VxModelsMutationDeleteCommentArgs = {
  commentID: Scalars['ID']['input'];
};


export type VxModelsMutationDeletePhotoArgs = {
  photoId: Scalars['ID']['input'];
};


export type VxModelsMutationDeletePostArgs = {
  postId: Scalars['ID']['input'];
};


export type VxModelsMutationEditCommentArgs = {
  commentID: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type VxModelsMutationEditPostArgs = {
  fsk: FskEnum;
  pinned: Scalars['Boolean']['input'];
  postId: Scalars['ID']['input'];
  publicationScheduledFor?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type VxModelsMutationPinPostArgs = {
  postId: Scalars['ID']['input'];
};


export type VxModelsMutationReportCommentArgs = {
  commentID: Scalars['ID']['input'];
};


export type VxModelsMutationSetUploadCompletedArgs = {
  postId: Scalars['ID']['input'];
};


export type VxModelsMutationUnpinPostArgs = {
  postId: Scalars['ID']['input'];
};

export type VxMutation = {
  __typename?: 'VXMutation';
  buyPost: BuyPostResult;
  commentPost?: Maybe<Comment>;
  deleteComment: Scalars['Boolean']['output'];
  editComment?: Maybe<Comment>;
  likePost: Post;
  reportComment: Scalars['Boolean']['output'];
  tipPost: TipPostResult;
  unlikePost: Post;
  viewedPost: Post;
};


export type VxMutationBuyPostArgs = {
  postId: Scalars['ID']['input'];
};


export type VxMutationCommentPostArgs = {
  postId: Scalars['ID']['input'];
  repliesToCommentId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};


export type VxMutationDeleteCommentArgs = {
  commentID: Scalars['ID']['input'];
};


export type VxMutationEditCommentArgs = {
  commentID: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type VxMutationLikePostArgs = {
  postId: Scalars['ID']['input'];
};


export type VxMutationReportCommentArgs = {
  commentID: Scalars['ID']['input'];
};


export type VxMutationTipPostArgs = {
  amount: Scalars['Float']['input'];
  postId: Scalars['ID']['input'];
};


export type VxMutationUnlikePostArgs = {
  postId: Scalars['ID']['input'];
};


export type VxMutationViewedPostArgs = {
  postId: Scalars['ID']['input'];
};

export type GetFeedPostsQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor: Scalars['String']['input'];
  categories?: InputMaybe<Array<FeedPostCategoriesEnum> | FeedPostCategoriesEnum>;
}>;


export type GetFeedPostsQuery = { __typename?: 'Query', feed: { __typename?: 'Feed', id: string, posts: { __typename?: 'Posts', pageInfo: { __typename?: 'PostsPageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'PostsEdge', cursor?: string | null, node: { __typename?: 'ClipPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, views: number, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, umaId?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, clip?: { __typename?: 'MediaVideo', length: number, sources: Array<{ __typename?: 'MediaVideoSource', src: string, type: string }>, poster?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null } | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, publicationScheduledFor?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, photos?: Array<{ __typename?: 'MediaPicture', id: string, url: string, srcSet: string, fsk: FskEnum, rejected: boolean, likes: number, deRejection?: string | null, enRejection?: string | null }> | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, contest?: { __typename?: 'Contest', id: string } | null } | { __typename?: 'TextPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, likes: number, title?: string | null, text?: string | null, fsk: FskEnum, type: PostTypeEnum, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } }> } } };

type FeedNode_ClipPost_Fragment = { __typename?: 'ClipPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, views: number, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, umaId?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, clip?: { __typename?: 'MediaVideo', length: number, sources: Array<{ __typename?: 'MediaVideoSource', src: string, type: string }>, poster?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null } | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

type FeedNode_PhotosPost_Fragment = { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, publicationScheduledFor?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, photos?: Array<{ __typename?: 'MediaPicture', id: string, url: string, srcSet: string, fsk: FskEnum, rejected: boolean, likes: number, deRejection?: string | null, enRejection?: string | null }> | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, contest?: { __typename?: 'Contest', id: string } | null };

type FeedNode_TextPost_Fragment = { __typename?: 'TextPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, likes: number, title?: string | null, text?: string | null, fsk: FskEnum, type: PostTypeEnum, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

export type FeedNodeFragment = FeedNode_ClipPost_Fragment | FeedNode_PhotosPost_Fragment | FeedNode_TextPost_Fragment;

export type TippingGoalFragment = { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null };

export type PinFeedPostMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type PinFeedPostMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', pinPost: { __typename?: 'PostUpdated', success: boolean } } };

export type UnpinFeedPostMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type UnpinFeedPostMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', unpinPost: { __typename?: 'PostUpdated', success: boolean } } };

export type DeleteFeedPostMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type DeleteFeedPostMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', deletePost: boolean } };

export type DeleteImageFeedPostMutationVariables = Exact<{
  photoId: Scalars['ID']['input'];
}>;


export type DeleteImageFeedPostMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', deletePhoto: boolean } };

export type ReplaceImageFeedPostUploadUrlQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
  photoId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReplaceImageFeedPostUploadUrlQuery = { __typename?: 'Query', uploadUrl?: string | null };

export type GetFeedPostQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type GetFeedPostQuery = { __typename?: 'Query', post?: { __typename?: 'ClipPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, views: number, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, umaId?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, clip?: { __typename?: 'MediaVideo', length: number, sources: Array<{ __typename?: 'MediaVideoSource', src: string, type: string }>, poster?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null } | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, publicationScheduledFor?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, photos?: Array<{ __typename?: 'MediaPicture', id: string, url: string, srcSet: string, fsk: FskEnum, rejected: boolean, likes: number, deRejection?: string | null, enRejection?: string | null }> | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, contest?: { __typename?: 'Contest', id: string } | null } | { __typename?: 'TextPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, likes: number, title?: string | null, text?: string | null, fsk: FskEnum, type: PostTypeEnum, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | null };

export type FeedClipPostFragment = { __typename?: 'ClipPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, views: number, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, umaId?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, clip?: { __typename?: 'MediaVideo', length: number, sources: Array<{ __typename?: 'MediaVideoSource', src: string, type: string }>, poster?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null } | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

export type FeedPhotoPostFragment = { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, publicationScheduledFor?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, photos?: Array<{ __typename?: 'MediaPicture', id: string, url: string, srcSet: string, fsk: FskEnum, rejected: boolean, likes: number, deRejection?: string | null, enRejection?: string | null }> | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, contest?: { __typename?: 'Contest', id: string } | null };

export type FeedPhotoMediaPictureFragment = { __typename?: 'MediaPicture', id: string, url: string, srcSet: string, fsk: FskEnum, rejected: boolean, likes: number, deRejection?: string | null, enRejection?: string | null };

export type FeedTextPostFragment = { __typename?: 'TextPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, likes: number, title?: string | null, text?: string | null, fsk: FskEnum, type: PostTypeEnum, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

export type GetFeedNonOkPostsQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFeedNonOkPostsQuery = { __typename?: 'Query', feed: { __typename?: 'Feed', id: string, nonOkPosts: { __typename?: 'Posts', pageInfo: { __typename?: 'PostsPageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'PostsEdge', cursor?: string | null, node: { __typename?: 'ClipPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, views: number, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, umaId?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, clip?: { __typename?: 'MediaVideo', length: number, sources: Array<{ __typename?: 'MediaVideoSource', src: string, type: string }>, poster?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null } | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, publicationScheduledFor?: string | null, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, photos?: Array<{ __typename?: 'MediaPicture', id: string, url: string, srcSet: string, fsk: FskEnum, rejected: boolean, likes: number, deRejection?: string | null, enRejection?: string | null }> | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, contest?: { __typename?: 'Contest', id: string } | null } | { __typename?: 'TextPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, likes: number, title?: string | null, text?: string | null, fsk: FskEnum, type: PostTypeEnum, deRejection?: string | null, enRejection?: string | null, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } }> } } };

export type GetFeedTotalCountQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type GetFeedTotalCountQuery = { __typename?: 'Query', feedTotalCounts: { __typename?: 'FeedTotalCount', totalCount: number } };

export type CreateFeedContestPostMutationVariables = Exact<{
  contestId: Scalars['ID']['input'];
}>;


export type CreateFeedContestPostMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', createPhotoContextPost: { __typename?: 'PhotoContestPostCreated', success: boolean, uploadUrl?: string | null, post?: { __typename?: 'ClipPost', id: string, type: PostTypeEnum, title?: string | null, text?: string | null, model: { __typename?: 'User', id: string } } | { __typename?: 'PhotosPost', id: string, type: PostTypeEnum, title?: string | null, text?: string | null, model: { __typename?: 'User', id: string } } | { __typename?: 'TextPost', id: string, type: PostTypeEnum, title?: string | null, text?: string | null, model: { __typename?: 'User', id: string } } | null } } };

export type CreateFeedPostMutationVariables = Exact<{
  postType: ModelPostTypesEnum;
  fsk: FskEnum;
  pinned: Scalars['Boolean']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  photosCount?: InputMaybe<Scalars['Int']['input']>;
  tippingGoal?: InputMaybe<Scalars['Float']['input']>;
  publicationScheduledFor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFeedPostMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', createPost: { __typename?: 'PostCreated', success: boolean, uploadUrls?: Array<string> | null, post?: { __typename?: 'ClipPost', id: string, umaId?: string | null } | { __typename?: 'PhotosPost', id: string, umaId?: string | null } | { __typename?: 'TextPost', id: string, umaId?: string | null } | null } } };

export type PaidContentConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type PaidContentConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', paidContent: { __typename?: 'PaidContentConfig', min: any, max: any, step: any }, tippingGoal: { __typename?: 'TippingGoalConfig', min: any, max: any, steps: Array<any | null> } } };

export type EditFeedPostMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
  fsk: FskEnum;
  pinned: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditFeedPostMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', editPost: { __typename?: 'PostUpdated', success: boolean } } };

export type GetFeedPostStatisticsProviderQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type GetFeedPostStatisticsProviderQuery = { __typename?: 'Query', post?: { __typename?: 'ClipPost', paidContent: boolean, id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, clip?: { __typename?: 'MediaVideo', poster?: { __typename?: 'MediaPicture', url: string } | null } | null, model: { __typename?: 'User', id: string }, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | { __typename?: 'PhotosPost', paidContent: boolean, id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, photos?: Array<{ __typename?: 'MediaPicture', url: string }> | null, model: { __typename?: 'User', id: string }, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | { __typename?: 'TextPost', paidContent: boolean, id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, model: { __typename?: 'User', id: string }, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | null, postLikes?: { __typename?: 'Likes', totalCount: number, likes: Array<{ __typename?: 'Like', likedAt: string, user?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string } | null } | null }> } | null, postTips?: { __typename?: 'Tips', totalCount: number, tips: Array<{ __typename?: 'Tip', tippedAt: string, amount?: any | null, user?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string } | null } | null }> } | null, postSales?: { __typename?: 'Sales', totalCount: number, sales: Array<{ __typename?: 'Sale', salesAt: string, user?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string } | null } | null }> } | null };

export type PostLikesFragment = { __typename?: 'Likes', totalCount: number, likes: Array<{ __typename?: 'Like', likedAt: string, user?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string } | null } | null }> };

export type PostTipsFragment = { __typename?: 'Tips', totalCount: number, tips: Array<{ __typename?: 'Tip', tippedAt: string, amount?: any | null, user?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string } | null } | null }> };

export type PostSalesFragment = { __typename?: 'Sales', totalCount: number, sales: Array<{ __typename?: 'Sale', salesAt: string, user?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string } | null } | null }> };

export type UserFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string } | null };

type Post_ClipPost_Fragment = { __typename?: 'ClipPost', paidContent: boolean, id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, clip?: { __typename?: 'MediaVideo', poster?: { __typename?: 'MediaPicture', url: string } | null } | null, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

type Post_PhotosPost_Fragment = { __typename?: 'PhotosPost', paidContent: boolean, id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, photos?: Array<{ __typename?: 'MediaPicture', url: string }> | null, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

type Post_TextPost_Fragment = { __typename?: 'TextPost', paidContent: boolean, id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

export type PostFragment = Post_ClipPost_Fragment | Post_PhotosPost_Fragment | Post_TextPost_Fragment;

export type GetFeedPostCommentingProviderQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type GetFeedPostCommentingProviderQuery = { __typename?: 'Query', account?: { __typename?: 'Account', user?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } | null } | null, post?: { __typename?: 'ClipPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, views: number, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, umaId?: string | null, deRejection?: string | null, enRejection?: string | null, commentEntries: { __typename?: 'Comments', totalCount: number, nodes: Array<{ __typename?: 'Conversation', comment: { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }, replies: Array<{ __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }> }> }, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, clip?: { __typename?: 'MediaVideo', length: number, sources: Array<{ __typename?: 'MediaVideoSource', src: string, type: string }>, poster?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null } | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, fsk: FskEnum, likes: number, title?: string | null, text?: string | null, type: PostTypeEnum, publicationScheduledFor?: string | null, deRejection?: string | null, enRejection?: string | null, commentEntries: { __typename?: 'Comments', totalCount: number, nodes: Array<{ __typename?: 'Conversation', comment: { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }, replies: Array<{ __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }> }> }, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, photos?: Array<{ __typename?: 'MediaPicture', id: string, url: string, srcSet: string, fsk: FskEnum, rejected: boolean, likes: number, deRejection?: string | null, enRejection?: string | null }> | null, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null, purchases?: { __typename?: 'PurchasesSummary', count: number } | null, contest?: { __typename?: 'Contest', id: string } | null } | { __typename?: 'TextPost', id: string, status: PostStatusEnum, rejected: boolean, created: string, pinned: boolean, price?: any | null, likes: number, title?: string | null, text?: string | null, fsk: FskEnum, type: PostTypeEnum, deRejection?: string | null, enRejection?: string | null, commentEntries: { __typename?: 'Comments', totalCount: number, nodes: Array<{ __typename?: 'Conversation', comment: { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }, replies: Array<{ __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }> }> }, model: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', url: string, srcSet: string } | null }, comments: { __typename?: 'Comments', totalCount: number }, tips: { __typename?: 'TipsSummary', count: number, amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null } | null };

export type CreateInitialCommentMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type CreateInitialCommentMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', commentPost?: { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } } | null } };

export type CreateEditCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type CreateEditCommentMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', editComment?: { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } } | null } };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', deleteComment: boolean } };

export type CreateReplyCommentMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
}>;


export type CreateReplyCommentMutation = { __typename?: 'Mutation', vxmodels: { __typename?: 'VXModelsMutation', commentPost?: { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } } | null } };

export type FeedUserAvatarFragment = { __typename?: 'MediaPicture', id: string, url: string };

export type FeedUserFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null };

export type FeedCommentFragment = { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } };

export type FeedReplyFragment = { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } };

export type FeedConversationFragment = { __typename?: 'Conversation', comment: { __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }, replies: Array<{ __typename?: 'Comment', id: string, created: string, text: string, isCreator: boolean, tipped: boolean, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'MediaPicture', id: string, url: string } | null } }> };

type FeedPost_ClipPost_Fragment = { __typename?: 'ClipPost', id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, clip?: { __typename?: 'MediaVideo', poster?: { __typename?: 'MediaPicture', url: string } | null } | null, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

type FeedPost_PhotosPost_Fragment = { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, photos?: Array<{ __typename?: 'MediaPicture', url: string }> | null, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

type FeedPost_TextPost_Fragment = { __typename?: 'TextPost', id: string, status: PostStatusEnum, type: PostTypeEnum, title?: string | null, text?: string | null, tips: { __typename?: 'TipsSummary', amount?: any | null }, tippingGoal?: { __typename?: 'TippingGoal', goal?: any | null, progressPercent: number, achieved: boolean, tipsSum?: any | null } | null };

export type FeedPostFragment = FeedPost_ClipPost_Fragment | FeedPost_PhotosPost_Fragment | FeedPost_TextPost_Fragment;

export type MarkPostAsUploadedMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type MarkPostAsUploadedMutation = { __typename?: 'Mutation', vxmodels: { __typename: 'VXModelsMutation', setUploadCompleted?: { __typename?: 'PostUpdated', success: boolean, post?: { __typename?: 'ClipPost', id: string, status: PostStatusEnum, rejectionReason?: string | null } | { __typename?: 'PhotosPost', id: string, status: PostStatusEnum, rejectionReason?: string | null } | { __typename?: 'TextPost', id: string, status: PostStatusEnum, rejectionReason?: string | null } | null } | null } };

export const TippingGoalFragmentDoc = gql`
    fragment TippingGoal on TippingGoal {
  goal
  progressPercent
  achieved
  tipsSum
}
    `;
export const FeedClipPostFragmentDoc = gql`
    fragment FeedClipPost on ClipPost {
  model {
    id
    name
    avatar {
      url
      srcSet
    }
  }
  clip {
    length
    sources {
      src
      type
    }
    poster {
      url(size: W640)
      srcSet
    }
  }
  comments {
    totalCount
  }
  tips {
    count
    amount
  }
  purchases {
    count
  }
  tippingGoal {
    ...TippingGoal
  }
  id
  status
  rejected
  deRejection: rejectionReason(language: DE)
  enRejection: rejectionReason(language: EN)
  created
  pinned
  price
  fsk
  views
  likes
  title
  text
  type
  umaId
}
    ${TippingGoalFragmentDoc}`;
export const FeedTextPostFragmentDoc = gql`
    fragment FeedTextPost on TextPost {
  model {
    id
    name
    avatar {
      url
      srcSet
    }
  }
  comments {
    totalCount
  }
  tips {
    count
    amount
  }
  tippingGoal {
    ...TippingGoal
  }
  id
  status
  rejected
  deRejection: rejectionReason(language: DE)
  enRejection: rejectionReason(language: EN)
  created
  pinned
  price
  likes
  title
  text
  fsk
  type
}
    ${TippingGoalFragmentDoc}`;
export const FeedPhotoMediaPictureFragmentDoc = gql`
    fragment FeedPhotoMediaPicture on MediaPicture {
  id
  url
  srcSet
  fsk
  rejected
  deRejection: rejectionReason(language: DE)
  enRejection: rejectionReason(language: EN)
  likes
}
    `;
export const FeedPhotoPostFragmentDoc = gql`
    fragment FeedPhotoPost on PhotosPost {
  id
  model {
    id
    name
    avatar {
      url
      srcSet
    }
  }
  photos {
    ...FeedPhotoMediaPicture
  }
  comments {
    totalCount
  }
  tips {
    count
    amount
  }
  tippingGoal {
    ...TippingGoal
  }
  purchases {
    count
  }
  id
  status
  rejected
  deRejection: rejectionReason(language: DE)
  enRejection: rejectionReason(language: EN)
  created
  pinned
  price
  fsk
  likes
  title
  text
  type
  publicationScheduledFor
  contest {
    id
  }
}
    ${FeedPhotoMediaPictureFragmentDoc}
${TippingGoalFragmentDoc}`;
export const FeedNodeFragmentDoc = gql`
    fragment FeedNode on Post {
  ... on ClipPost {
    ...FeedClipPost
  }
  ... on TextPost {
    ...FeedTextPost
  }
  ... on PhotosPost {
    ...FeedPhotoPost
  }
}
    ${FeedClipPostFragmentDoc}
${FeedTextPostFragmentDoc}
${FeedPhotoPostFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  avatar {
    url
  }
}
    `;
export const PostLikesFragmentDoc = gql`
    fragment PostLikes on Likes {
  totalCount
  likes {
    likedAt
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export const PostTipsFragmentDoc = gql`
    fragment PostTips on Tips {
  totalCount
  tips {
    tippedAt
    amount
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export const PostSalesFragmentDoc = gql`
    fragment PostSales on Sales {
  totalCount
  sales {
    salesAt
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export const FeedPostFragmentDoc = gql`
    fragment FeedPost on Post {
  id
  status
  type
  title
  text
  tips {
    amount
  }
  tippingGoal {
    ...TippingGoal
  }
  ... on PhotosPost {
    photos {
      url(size: W60)
    }
  }
  ... on ClipPost {
    clip {
      poster {
        url(size: W60)
      }
    }
  }
}
    ${TippingGoalFragmentDoc}`;
export const PostFragmentDoc = gql`
    fragment Post on Post {
  ...FeedPost
  paidContent
}
    ${FeedPostFragmentDoc}`;
export const FeedUserAvatarFragmentDoc = gql`
    fragment FeedUserAvatar on MediaPicture {
  id
  url(size: W60)
}
    `;
export const FeedUserFragmentDoc = gql`
    fragment FeedUser on User {
  id
  name
  avatar {
    ...FeedUserAvatar
  }
}
    ${FeedUserAvatarFragmentDoc}`;
export const FeedCommentFragmentDoc = gql`
    fragment FeedComment on Comment {
  id
  created
  text
  isCreator
  tipped
  user {
    ...FeedUser
  }
}
    ${FeedUserFragmentDoc}`;
export const FeedReplyFragmentDoc = gql`
    fragment FeedReply on Comment {
  id
  created
  text
  isCreator
  tipped
  user {
    ...FeedUser
  }
}
    ${FeedUserFragmentDoc}`;
export const FeedConversationFragmentDoc = gql`
    fragment FeedConversation on Conversation {
  comment {
    ...FeedComment
  }
  replies {
    ...FeedReply
  }
}
    ${FeedCommentFragmentDoc}
${FeedReplyFragmentDoc}`;
export const GetFeedPostsDocument = gql`
    query GetFeedPosts($modelId: ID!, $count: Int!, $cursor: String!, $categories: [FeedPostCategoriesEnum!]) {
  feed(
    modelId: $modelId
    statusList: [OK, UPLOADING, TRANSCODING, REJECTED, BROKEN, SCHEDULED]
    categories: $categories
  ) {
    id
    posts(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...FeedNode
        }
      }
    }
  }
}
    ${FeedNodeFragmentDoc}`;

/**
 * __useGetFeedPostsQuery__
 *
 * To run a query within a React component, call `useGetFeedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedPostsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useGetFeedPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeedPostsQuery, GetFeedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedPostsQuery, GetFeedPostsQueryVariables>(GetFeedPostsDocument, options);
      }
export function useGetFeedPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedPostsQuery, GetFeedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedPostsQuery, GetFeedPostsQueryVariables>(GetFeedPostsDocument, options);
        }
export function useGetFeedPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeedPostsQuery, GetFeedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedPostsQuery, GetFeedPostsQueryVariables>(GetFeedPostsDocument, options);
        }
export type GetFeedPostsQueryHookResult = ReturnType<typeof useGetFeedPostsQuery>;
export type GetFeedPostsLazyQueryHookResult = ReturnType<typeof useGetFeedPostsLazyQuery>;
export type GetFeedPostsSuspenseQueryHookResult = ReturnType<typeof useGetFeedPostsSuspenseQuery>;
export type GetFeedPostsQueryResult = Apollo.QueryResult<GetFeedPostsQuery, GetFeedPostsQueryVariables>;
export const PinFeedPostDocument = gql`
    mutation PinFeedPost($postId: ID!) {
  vxmodels {
    pinPost(postId: $postId) {
      success
    }
  }
}
    `;
export type PinFeedPostMutationFn = Apollo.MutationFunction<PinFeedPostMutation, PinFeedPostMutationVariables>;

/**
 * __usePinFeedPostMutation__
 *
 * To run a mutation, you first call `usePinFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinFeedPostMutation, { data, loading, error }] = usePinFeedPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePinFeedPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PinFeedPostMutation, PinFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PinFeedPostMutation, PinFeedPostMutationVariables>(PinFeedPostDocument, options);
      }
export type PinFeedPostMutationHookResult = ReturnType<typeof usePinFeedPostMutation>;
export type PinFeedPostMutationResult = Apollo.MutationResult<PinFeedPostMutation>;
export type PinFeedPostMutationOptions = Apollo.BaseMutationOptions<PinFeedPostMutation, PinFeedPostMutationVariables>;
export const UnpinFeedPostDocument = gql`
    mutation UnpinFeedPost($postId: ID!) {
  vxmodels {
    unpinPost(postId: $postId) {
      success
    }
  }
}
    `;
export type UnpinFeedPostMutationFn = Apollo.MutationFunction<UnpinFeedPostMutation, UnpinFeedPostMutationVariables>;

/**
 * __useUnpinFeedPostMutation__
 *
 * To run a mutation, you first call `useUnpinFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinFeedPostMutation, { data, loading, error }] = useUnpinFeedPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useUnpinFeedPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnpinFeedPostMutation, UnpinFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnpinFeedPostMutation, UnpinFeedPostMutationVariables>(UnpinFeedPostDocument, options);
      }
export type UnpinFeedPostMutationHookResult = ReturnType<typeof useUnpinFeedPostMutation>;
export type UnpinFeedPostMutationResult = Apollo.MutationResult<UnpinFeedPostMutation>;
export type UnpinFeedPostMutationOptions = Apollo.BaseMutationOptions<UnpinFeedPostMutation, UnpinFeedPostMutationVariables>;
export const DeleteFeedPostDocument = gql`
    mutation DeleteFeedPost($postId: ID!) {
  vxmodels {
    deletePost(postId: $postId)
  }
}
    `;
export type DeleteFeedPostMutationFn = Apollo.MutationFunction<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>;

/**
 * __useDeleteFeedPostMutation__
 *
 * To run a mutation, you first call `useDeleteFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedPostMutation, { data, loading, error }] = useDeleteFeedPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeleteFeedPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>(DeleteFeedPostDocument, options);
      }
export type DeleteFeedPostMutationHookResult = ReturnType<typeof useDeleteFeedPostMutation>;
export type DeleteFeedPostMutationResult = Apollo.MutationResult<DeleteFeedPostMutation>;
export type DeleteFeedPostMutationOptions = Apollo.BaseMutationOptions<DeleteFeedPostMutation, DeleteFeedPostMutationVariables>;
export const DeleteImageFeedPostDocument = gql`
    mutation DeleteImageFeedPost($photoId: ID!) {
  vxmodels {
    deletePhoto(photoId: $photoId)
  }
}
    `;
export type DeleteImageFeedPostMutationFn = Apollo.MutationFunction<DeleteImageFeedPostMutation, DeleteImageFeedPostMutationVariables>;

/**
 * __useDeleteImageFeedPostMutation__
 *
 * To run a mutation, you first call `useDeleteImageFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageFeedPostMutation, { data, loading, error }] = useDeleteImageFeedPostMutation({
 *   variables: {
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useDeleteImageFeedPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteImageFeedPostMutation, DeleteImageFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteImageFeedPostMutation, DeleteImageFeedPostMutationVariables>(DeleteImageFeedPostDocument, options);
      }
export type DeleteImageFeedPostMutationHookResult = ReturnType<typeof useDeleteImageFeedPostMutation>;
export type DeleteImageFeedPostMutationResult = Apollo.MutationResult<DeleteImageFeedPostMutation>;
export type DeleteImageFeedPostMutationOptions = Apollo.BaseMutationOptions<DeleteImageFeedPostMutation, DeleteImageFeedPostMutationVariables>;
export const ReplaceImageFeedPostUploadUrlDocument = gql`
    query ReplaceImageFeedPostUploadUrl($postId: ID!, $photoId: ID) {
  uploadUrl(postId: $postId, photoId: $photoId)
}
    `;

/**
 * __useReplaceImageFeedPostUploadUrlQuery__
 *
 * To run a query within a React component, call `useReplaceImageFeedPostUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplaceImageFeedPostUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplaceImageFeedPostUploadUrlQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useReplaceImageFeedPostUploadUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReplaceImageFeedPostUploadUrlQuery, ReplaceImageFeedPostUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReplaceImageFeedPostUploadUrlQuery, ReplaceImageFeedPostUploadUrlQueryVariables>(ReplaceImageFeedPostUploadUrlDocument, options);
      }
export function useReplaceImageFeedPostUploadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReplaceImageFeedPostUploadUrlQuery, ReplaceImageFeedPostUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReplaceImageFeedPostUploadUrlQuery, ReplaceImageFeedPostUploadUrlQueryVariables>(ReplaceImageFeedPostUploadUrlDocument, options);
        }
export function useReplaceImageFeedPostUploadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReplaceImageFeedPostUploadUrlQuery, ReplaceImageFeedPostUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReplaceImageFeedPostUploadUrlQuery, ReplaceImageFeedPostUploadUrlQueryVariables>(ReplaceImageFeedPostUploadUrlDocument, options);
        }
export type ReplaceImageFeedPostUploadUrlQueryHookResult = ReturnType<typeof useReplaceImageFeedPostUploadUrlQuery>;
export type ReplaceImageFeedPostUploadUrlLazyQueryHookResult = ReturnType<typeof useReplaceImageFeedPostUploadUrlLazyQuery>;
export type ReplaceImageFeedPostUploadUrlSuspenseQueryHookResult = ReturnType<typeof useReplaceImageFeedPostUploadUrlSuspenseQuery>;
export type ReplaceImageFeedPostUploadUrlQueryResult = Apollo.QueryResult<ReplaceImageFeedPostUploadUrlQuery, ReplaceImageFeedPostUploadUrlQueryVariables>;
export const GetFeedPostDocument = gql`
    query GetFeedPost($postId: ID!) {
  post(postId: $postId) {
    ...FeedNode
  }
}
    ${FeedNodeFragmentDoc}`;

/**
 * __useGetFeedPostQuery__
 *
 * To run a query within a React component, call `useGetFeedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetFeedPostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeedPostQuery, GetFeedPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedPostQuery, GetFeedPostQueryVariables>(GetFeedPostDocument, options);
      }
export function useGetFeedPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedPostQuery, GetFeedPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedPostQuery, GetFeedPostQueryVariables>(GetFeedPostDocument, options);
        }
export function useGetFeedPostSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeedPostQuery, GetFeedPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedPostQuery, GetFeedPostQueryVariables>(GetFeedPostDocument, options);
        }
export type GetFeedPostQueryHookResult = ReturnType<typeof useGetFeedPostQuery>;
export type GetFeedPostLazyQueryHookResult = ReturnType<typeof useGetFeedPostLazyQuery>;
export type GetFeedPostSuspenseQueryHookResult = ReturnType<typeof useGetFeedPostSuspenseQuery>;
export type GetFeedPostQueryResult = Apollo.QueryResult<GetFeedPostQuery, GetFeedPostQueryVariables>;
export const GetFeedNonOkPostsDocument = gql`
    query GetFeedNonOkPosts($modelId: ID!, $count: Int!, $cursor: String) {
  feed(modelId: $modelId, statusList: [REJECTED, BROKEN]) {
    id
    nonOkPosts: posts(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...FeedNode
        }
      }
    }
  }
}
    ${FeedNodeFragmentDoc}`;

/**
 * __useGetFeedNonOkPostsQuery__
 *
 * To run a query within a React component, call `useGetFeedNonOkPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedNonOkPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedNonOkPostsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetFeedNonOkPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeedNonOkPostsQuery, GetFeedNonOkPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedNonOkPostsQuery, GetFeedNonOkPostsQueryVariables>(GetFeedNonOkPostsDocument, options);
      }
export function useGetFeedNonOkPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedNonOkPostsQuery, GetFeedNonOkPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedNonOkPostsQuery, GetFeedNonOkPostsQueryVariables>(GetFeedNonOkPostsDocument, options);
        }
export function useGetFeedNonOkPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeedNonOkPostsQuery, GetFeedNonOkPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedNonOkPostsQuery, GetFeedNonOkPostsQueryVariables>(GetFeedNonOkPostsDocument, options);
        }
export type GetFeedNonOkPostsQueryHookResult = ReturnType<typeof useGetFeedNonOkPostsQuery>;
export type GetFeedNonOkPostsLazyQueryHookResult = ReturnType<typeof useGetFeedNonOkPostsLazyQuery>;
export type GetFeedNonOkPostsSuspenseQueryHookResult = ReturnType<typeof useGetFeedNonOkPostsSuspenseQuery>;
export type GetFeedNonOkPostsQueryResult = Apollo.QueryResult<GetFeedNonOkPostsQuery, GetFeedNonOkPostsQueryVariables>;
export const GetFeedTotalCountDocument = gql`
    query GetFeedTotalCount($modelId: ID!) {
  feedTotalCounts(modelId: $modelId) {
    totalCount
  }
}
    `;

/**
 * __useGetFeedTotalCountQuery__
 *
 * To run a query within a React component, call `useGetFeedTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedTotalCountQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetFeedTotalCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeedTotalCountQuery, GetFeedTotalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedTotalCountQuery, GetFeedTotalCountQueryVariables>(GetFeedTotalCountDocument, options);
      }
export function useGetFeedTotalCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedTotalCountQuery, GetFeedTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedTotalCountQuery, GetFeedTotalCountQueryVariables>(GetFeedTotalCountDocument, options);
        }
export function useGetFeedTotalCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeedTotalCountQuery, GetFeedTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedTotalCountQuery, GetFeedTotalCountQueryVariables>(GetFeedTotalCountDocument, options);
        }
export type GetFeedTotalCountQueryHookResult = ReturnType<typeof useGetFeedTotalCountQuery>;
export type GetFeedTotalCountLazyQueryHookResult = ReturnType<typeof useGetFeedTotalCountLazyQuery>;
export type GetFeedTotalCountSuspenseQueryHookResult = ReturnType<typeof useGetFeedTotalCountSuspenseQuery>;
export type GetFeedTotalCountQueryResult = Apollo.QueryResult<GetFeedTotalCountQuery, GetFeedTotalCountQueryVariables>;
export const CreateFeedContestPostDocument = gql`
    mutation CreateFeedContestPost($contestId: ID!) {
  vxmodels {
    createPhotoContextPost(contestId: $contestId) {
      success
      uploadUrl
      post {
        id
        type
        title
        text
        model {
          id
        }
      }
    }
  }
}
    `;
export type CreateFeedContestPostMutationFn = Apollo.MutationFunction<CreateFeedContestPostMutation, CreateFeedContestPostMutationVariables>;

/**
 * __useCreateFeedContestPostMutation__
 *
 * To run a mutation, you first call `useCreateFeedContestPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedContestPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedContestPostMutation, { data, loading, error }] = useCreateFeedContestPostMutation({
 *   variables: {
 *      contestId: // value for 'contestId'
 *   },
 * });
 */
export function useCreateFeedContestPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFeedContestPostMutation, CreateFeedContestPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFeedContestPostMutation, CreateFeedContestPostMutationVariables>(CreateFeedContestPostDocument, options);
      }
export type CreateFeedContestPostMutationHookResult = ReturnType<typeof useCreateFeedContestPostMutation>;
export type CreateFeedContestPostMutationResult = Apollo.MutationResult<CreateFeedContestPostMutation>;
export type CreateFeedContestPostMutationOptions = Apollo.BaseMutationOptions<CreateFeedContestPostMutation, CreateFeedContestPostMutationVariables>;
export const CreateFeedPostDocument = gql`
    mutation CreateFeedPost($postType: ModelPostTypesEnum!, $fsk: FskEnum!, $pinned: Boolean!, $price: Float, $text: String, $title: String, $photosCount: Int, $tippingGoal: Float, $publicationScheduledFor: String) {
  vxmodels {
    createPost(
      type: $postType
      fsk: $fsk
      pinned: $pinned
      price: $price
      title: $title
      text: $text
      photosCount: $photosCount
      tippingGoal: $tippingGoal
      publicationScheduledFor: $publicationScheduledFor
    ) {
      post {
        id
        umaId
      }
      success
      uploadUrls
    }
  }
}
    `;
export type CreateFeedPostMutationFn = Apollo.MutationFunction<CreateFeedPostMutation, CreateFeedPostMutationVariables>;

/**
 * __useCreateFeedPostMutation__
 *
 * To run a mutation, you first call `useCreateFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedPostMutation, { data, loading, error }] = useCreateFeedPostMutation({
 *   variables: {
 *      postType: // value for 'postType'
 *      fsk: // value for 'fsk'
 *      pinned: // value for 'pinned'
 *      price: // value for 'price'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *      photosCount: // value for 'photosCount'
 *      tippingGoal: // value for 'tippingGoal'
 *      publicationScheduledFor: // value for 'publicationScheduledFor'
 *   },
 * });
 */
export function useCreateFeedPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFeedPostMutation, CreateFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFeedPostMutation, CreateFeedPostMutationVariables>(CreateFeedPostDocument, options);
      }
export type CreateFeedPostMutationHookResult = ReturnType<typeof useCreateFeedPostMutation>;
export type CreateFeedPostMutationResult = Apollo.MutationResult<CreateFeedPostMutation>;
export type CreateFeedPostMutationOptions = Apollo.BaseMutationOptions<CreateFeedPostMutation, CreateFeedPostMutationVariables>;
export const PaidContentConfigDocument = gql`
    query PaidContentConfig {
  config {
    paidContent {
      min
      max
      step
    }
    tippingGoal {
      min
      max
      steps
    }
  }
}
    `;

/**
 * __usePaidContentConfigQuery__
 *
 * To run a query within a React component, call `usePaidContentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidContentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidContentConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaidContentConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaidContentConfigQuery, PaidContentConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaidContentConfigQuery, PaidContentConfigQueryVariables>(PaidContentConfigDocument, options);
      }
export function usePaidContentConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaidContentConfigQuery, PaidContentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaidContentConfigQuery, PaidContentConfigQueryVariables>(PaidContentConfigDocument, options);
        }
export function usePaidContentConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaidContentConfigQuery, PaidContentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaidContentConfigQuery, PaidContentConfigQueryVariables>(PaidContentConfigDocument, options);
        }
export type PaidContentConfigQueryHookResult = ReturnType<typeof usePaidContentConfigQuery>;
export type PaidContentConfigLazyQueryHookResult = ReturnType<typeof usePaidContentConfigLazyQuery>;
export type PaidContentConfigSuspenseQueryHookResult = ReturnType<typeof usePaidContentConfigSuspenseQuery>;
export type PaidContentConfigQueryResult = Apollo.QueryResult<PaidContentConfigQuery, PaidContentConfigQueryVariables>;
export const EditFeedPostDocument = gql`
    mutation EditFeedPost($postId: ID!, $fsk: FskEnum!, $pinned: Boolean!, $text: String, $title: String) {
  vxmodels {
    editPost(
      postId: $postId
      fsk: $fsk
      pinned: $pinned
      text: $text
      title: $title
    ) {
      success
    }
  }
}
    `;
export type EditFeedPostMutationFn = Apollo.MutationFunction<EditFeedPostMutation, EditFeedPostMutationVariables>;

/**
 * __useEditFeedPostMutation__
 *
 * To run a mutation, you first call `useEditFeedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFeedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFeedPostMutation, { data, loading, error }] = useEditFeedPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      fsk: // value for 'fsk'
 *      pinned: // value for 'pinned'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useEditFeedPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditFeedPostMutation, EditFeedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditFeedPostMutation, EditFeedPostMutationVariables>(EditFeedPostDocument, options);
      }
export type EditFeedPostMutationHookResult = ReturnType<typeof useEditFeedPostMutation>;
export type EditFeedPostMutationResult = Apollo.MutationResult<EditFeedPostMutation>;
export type EditFeedPostMutationOptions = Apollo.BaseMutationOptions<EditFeedPostMutation, EditFeedPostMutationVariables>;
export const GetFeedPostStatisticsProviderDocument = gql`
    query GetFeedPostStatisticsProvider($postId: ID!) {
  post(postId: $postId) {
    ...Post
    ... on PhotosPost {
      photos {
        url(size: W60)
      }
    }
    ... on ClipPost {
      clip {
        poster {
          url(size: W60)
        }
      }
    }
    model {
      id
    }
  }
  postLikes(postId: $postId) {
    ...PostLikes
  }
  postTips(postId: $postId) {
    ...PostTips
  }
  postSales(postId: $postId) {
    ...PostSales
  }
}
    ${PostFragmentDoc}
${PostLikesFragmentDoc}
${PostTipsFragmentDoc}
${PostSalesFragmentDoc}`;

/**
 * __useGetFeedPostStatisticsProviderQuery__
 *
 * To run a query within a React component, call `useGetFeedPostStatisticsProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedPostStatisticsProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedPostStatisticsProviderQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetFeedPostStatisticsProviderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeedPostStatisticsProviderQuery, GetFeedPostStatisticsProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedPostStatisticsProviderQuery, GetFeedPostStatisticsProviderQueryVariables>(GetFeedPostStatisticsProviderDocument, options);
      }
export function useGetFeedPostStatisticsProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedPostStatisticsProviderQuery, GetFeedPostStatisticsProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedPostStatisticsProviderQuery, GetFeedPostStatisticsProviderQueryVariables>(GetFeedPostStatisticsProviderDocument, options);
        }
export function useGetFeedPostStatisticsProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeedPostStatisticsProviderQuery, GetFeedPostStatisticsProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedPostStatisticsProviderQuery, GetFeedPostStatisticsProviderQueryVariables>(GetFeedPostStatisticsProviderDocument, options);
        }
export type GetFeedPostStatisticsProviderQueryHookResult = ReturnType<typeof useGetFeedPostStatisticsProviderQuery>;
export type GetFeedPostStatisticsProviderLazyQueryHookResult = ReturnType<typeof useGetFeedPostStatisticsProviderLazyQuery>;
export type GetFeedPostStatisticsProviderSuspenseQueryHookResult = ReturnType<typeof useGetFeedPostStatisticsProviderSuspenseQuery>;
export type GetFeedPostStatisticsProviderQueryResult = Apollo.QueryResult<GetFeedPostStatisticsProviderQuery, GetFeedPostStatisticsProviderQueryVariables>;
export const GetFeedPostCommentingProviderDocument = gql`
    query GetFeedPostCommentingProvider($postId: ID!) {
  account {
    user {
      ...FeedUser
    }
  }
  post(postId: $postId) {
    ...FeedNode
    commentEntries: comments {
      totalCount
      nodes {
        ...FeedConversation
      }
    }
  }
}
    ${FeedUserFragmentDoc}
${FeedNodeFragmentDoc}
${FeedConversationFragmentDoc}`;

/**
 * __useGetFeedPostCommentingProviderQuery__
 *
 * To run a query within a React component, call `useGetFeedPostCommentingProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedPostCommentingProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedPostCommentingProviderQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetFeedPostCommentingProviderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeedPostCommentingProviderQuery, GetFeedPostCommentingProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedPostCommentingProviderQuery, GetFeedPostCommentingProviderQueryVariables>(GetFeedPostCommentingProviderDocument, options);
      }
export function useGetFeedPostCommentingProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedPostCommentingProviderQuery, GetFeedPostCommentingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedPostCommentingProviderQuery, GetFeedPostCommentingProviderQueryVariables>(GetFeedPostCommentingProviderDocument, options);
        }
export function useGetFeedPostCommentingProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeedPostCommentingProviderQuery, GetFeedPostCommentingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedPostCommentingProviderQuery, GetFeedPostCommentingProviderQueryVariables>(GetFeedPostCommentingProviderDocument, options);
        }
export type GetFeedPostCommentingProviderQueryHookResult = ReturnType<typeof useGetFeedPostCommentingProviderQuery>;
export type GetFeedPostCommentingProviderLazyQueryHookResult = ReturnType<typeof useGetFeedPostCommentingProviderLazyQuery>;
export type GetFeedPostCommentingProviderSuspenseQueryHookResult = ReturnType<typeof useGetFeedPostCommentingProviderSuspenseQuery>;
export type GetFeedPostCommentingProviderQueryResult = Apollo.QueryResult<GetFeedPostCommentingProviderQuery, GetFeedPostCommentingProviderQueryVariables>;
export const CreateInitialCommentDocument = gql`
    mutation CreateInitialComment($postId: ID!, $text: String!) {
  vxmodels {
    commentPost(postId: $postId, text: $text) {
      ...FeedComment
    }
  }
}
    ${FeedCommentFragmentDoc}`;
export type CreateInitialCommentMutationFn = Apollo.MutationFunction<CreateInitialCommentMutation, CreateInitialCommentMutationVariables>;

/**
 * __useCreateInitialCommentMutation__
 *
 * To run a mutation, you first call `useCreateInitialCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInitialCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInitialCommentMutation, { data, loading, error }] = useCreateInitialCommentMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateInitialCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInitialCommentMutation, CreateInitialCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInitialCommentMutation, CreateInitialCommentMutationVariables>(CreateInitialCommentDocument, options);
      }
export type CreateInitialCommentMutationHookResult = ReturnType<typeof useCreateInitialCommentMutation>;
export type CreateInitialCommentMutationResult = Apollo.MutationResult<CreateInitialCommentMutation>;
export type CreateInitialCommentMutationOptions = Apollo.BaseMutationOptions<CreateInitialCommentMutation, CreateInitialCommentMutationVariables>;
export const CreateEditCommentDocument = gql`
    mutation CreateEditComment($commentId: ID!, $text: String!) {
  vxmodels {
    editComment(commentID: $commentId, text: $text) {
      ...FeedComment
    }
  }
}
    ${FeedCommentFragmentDoc}`;
export type CreateEditCommentMutationFn = Apollo.MutationFunction<CreateEditCommentMutation, CreateEditCommentMutationVariables>;

/**
 * __useCreateEditCommentMutation__
 *
 * To run a mutation, you first call `useCreateEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEditCommentMutation, { data, loading, error }] = useCreateEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateEditCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEditCommentMutation, CreateEditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEditCommentMutation, CreateEditCommentMutationVariables>(CreateEditCommentDocument, options);
      }
export type CreateEditCommentMutationHookResult = ReturnType<typeof useCreateEditCommentMutation>;
export type CreateEditCommentMutationResult = Apollo.MutationResult<CreateEditCommentMutation>;
export type CreateEditCommentMutationOptions = Apollo.BaseMutationOptions<CreateEditCommentMutation, CreateEditCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: ID!) {
  vxmodels {
    deleteComment(commentID: $commentId)
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const CreateReplyCommentDocument = gql`
    mutation CreateReplyComment($postId: ID!, $text: String!, $commentId: ID!) {
  vxmodels {
    commentPost(postId: $postId, text: $text, repliesToCommentId: $commentId) {
      ...FeedComment
    }
  }
}
    ${FeedCommentFragmentDoc}`;
export type CreateReplyCommentMutationFn = Apollo.MutationFunction<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>;

/**
 * __useCreateReplyCommentMutation__
 *
 * To run a mutation, you first call `useCreateReplyCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplyCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplyCommentMutation, { data, loading, error }] = useCreateReplyCommentMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      text: // value for 'text'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useCreateReplyCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>(CreateReplyCommentDocument, options);
      }
export type CreateReplyCommentMutationHookResult = ReturnType<typeof useCreateReplyCommentMutation>;
export type CreateReplyCommentMutationResult = Apollo.MutationResult<CreateReplyCommentMutation>;
export type CreateReplyCommentMutationOptions = Apollo.BaseMutationOptions<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>;
export const MarkPostAsUploadedDocument = gql`
    mutation MarkPostAsUploaded($postId: ID!) {
  vxmodels {
    __typename
    setUploadCompleted(postId: $postId) {
      success
      post {
        id
        status
        rejectionReason
      }
    }
  }
}
    `;
export type MarkPostAsUploadedMutationFn = Apollo.MutationFunction<MarkPostAsUploadedMutation, MarkPostAsUploadedMutationVariables>;

/**
 * __useMarkPostAsUploadedMutation__
 *
 * To run a mutation, you first call `useMarkPostAsUploadedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPostAsUploadedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPostAsUploadedMutation, { data, loading, error }] = useMarkPostAsUploadedMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useMarkPostAsUploadedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkPostAsUploadedMutation, MarkPostAsUploadedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkPostAsUploadedMutation, MarkPostAsUploadedMutationVariables>(MarkPostAsUploadedDocument, options);
      }
export type MarkPostAsUploadedMutationHookResult = ReturnType<typeof useMarkPostAsUploadedMutation>;
export type MarkPostAsUploadedMutationResult = Apollo.MutationResult<MarkPostAsUploadedMutation>;
export type MarkPostAsUploadedMutationOptions = Apollo.BaseMutationOptions<MarkPostAsUploadedMutation, MarkPostAsUploadedMutationVariables>;